import '.fe{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ff{padding-left:1.5rem;}.ssr-plugin'
import '.fg{margin:1rem 0;}.ssr-plugin'
import '.fh{color:var(--gray-700);}.ssr-plugin'
import '.fi{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fe ff fg fh fi"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
